module.exports = "<div gw-loader=\"accountDetailsPromise\">    \n    <gw-commissions-summary account=\"accountInfo\"/>\n</div>"